import MapModal from '@ui/Product/Map/Modal/component'
import type { ModalType } from '@ui/Modal/component'

export default function (): void {
  let mapInitialized = false
  let mapElement: HTMLElement | null
  let modal: ModalType | null = null

  document.querySelectorAll('.open-map-full').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement) {
      mapElement = this

      if (!mapInitialized) {
        const mapModal = MapModal()
        modal = mapModal ? mapModal : null

        modal?.getElement().addEventListener('modal.opened', () => {
          if (!mapElement) {
            return
          }
          mapElement.dispatchEvent(new CustomEvent('product.map.modal.opened'))
        })

        modal?.getElement().addEventListener('modal.closed', () => {
          if (!mapElement) {
            return
          }
          mapElement.dispatchEvent(new CustomEvent('product.map.modal.closed'))
        })
        mapInitialized = true
      }

      modal?.open()
    })
  })
}
